// extracted by mini-css-extract-plugin
export default {"page":"page-YcxD"};